export default __webpack_public_path__ + "static/media/014-no turn left.7a57b70b.png";